module.exports = __webpack_public_path__ + "img/icon-check-circle.e9fea91b.svg";